import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePullToRefreshRef } from '../context/PullToRefreshContext';
import { api } from '../api/client';

function BellIcon({ count, onOpen }) {
  return (
    <button
      type="button"
      className="relative p-2"
      onClick={onOpen}
    >
      <svg className="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
      </svg>
      {count > 0 && (
        <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  );
}

const tabs = [
  {
    to: '/satis',
    label: 'İşler',
    icon: (active) => (
      <svg className={`w-6 h-6 ${active ? 'text-brand-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    ),
  },
  {
    to: '/calendar',
    label: 'Takvim',
    icon: (active) => (
      <svg className={`w-6 h-6 ${active ? 'text-brand-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2zM9 12h.01M12 12h.01M15 12h.01M9 15h.01M12 15h.01" />
      </svg>
    ),
  },
  {
    to: '/satis/customers',
    label: 'Müşteriler',
    icon: (active) => (
      <svg className={`w-6 h-6 ${active ? 'text-brand-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
  },
  {
    to: '/satis/reports',
    label: 'Raporlar',
    icon: (active) => (
      <svg className={`w-6 h-6 ${active ? 'text-brand-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    to: '/satis/leave',
    label: 'İzin',
    icon: (active) => (
      <svg className={`w-6 h-6 ${active ? 'text-brand-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    to: '/satis/feedback',
    label: 'Mesaj',
    icon: (active) => (
      <svg className={`w-6 h-6 ${active ? 'text-brand-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
    ),
  },
];

const ROLE_LABEL = { admin: 'Admin', manager: 'Müdür', sales: 'Satış' };
const NOTIFY_RETURN_KEY = 'cetakip-notify-return';
const CUSTOMER_RETURN_KEY = 'cetakip-customer-return';

function useShowBack(pathname) {
  // Geri butonu gösterilecek sayfa kalıpları
  return (
    /^\/satis\/tasks\/\d+/.test(pathname) ||
    /^\/satis\/customers\/\d+/.test(pathname)
  );
}

const PULL_THRESHOLD = 65;

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const showBack = useShowBack(location.pathname);
  const [unread, setUnread] = useState(0);
  const [unreadFeedback, setUnreadFeedback] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const mainRef = useRef(null);
  const startYRef = useRef(0);
  const startXRef = useRef(0);
  const pullingRef = useRef(false);
  const pullYRef = useRef(0);
  const rafRef = useRef(null);
  const [pullDisplay, setPullDisplay] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const refreshFnRef = usePullToRefreshRef();

  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;

    const scheduleUpdate = () => {
      if (!rafRef.current) {
        rafRef.current = requestAnimationFrame(() => {
          setPullDisplay(pullYRef.current);
          rafRef.current = null;
        });
      }
    };

    const onTouchStart = (e) => {
      if (el.scrollTop > 0) return;
      startYRef.current = e.touches[0].clientY;
      startXRef.current = e.touches[0].clientX;
      pullingRef.current = true;
      pullYRef.current = 0;
    };

    const onTouchMove = (e) => {
      if (!pullingRef.current) return;
      const dy = e.touches[0].clientY - startYRef.current;
      const dx = Math.abs(e.touches[0].clientX - startXRef.current);
      if (dx > 30 || dy <= 0) {
        pullingRef.current = false;
        pullYRef.current = 0;
        scheduleUpdate();
        return;
      }
      pullYRef.current = Math.min(dy * 0.5, PULL_THRESHOLD);
      scheduleUpdate();
    };

    const onTouchEnd = async () => {
      if (!pullingRef.current) return;
      const reached = pullYRef.current >= PULL_THRESHOLD * 0.85;
      pullingRef.current = false;
      pullYRef.current = 0;
      setPullDisplay(0);
      if (reached && refreshFnRef?.current) {
        setRefreshing(true);
        try { await refreshFnRef.current(); } catch (_) {}
        setRefreshing(false);
      }
    };

    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchmove', onTouchMove, { passive: true });
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchEnd);

    return () => {
      el.removeEventListener('touchstart', onTouchStart);
      el.removeEventListener('touchmove', onTouchMove);
      el.removeEventListener('touchend', onTouchEnd);
      el.removeEventListener('touchcancel', onTouchEnd);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [refreshFnRef]);

  useEffect(() => {
    const fetchUnread = () => {
      api.getNotifications()
        .then(({ data }) => setUnread(data.unread_count || 0))
        .catch(() => {});
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);

    // NotificationPage'den anlık güncelleme
    const handleUnreadChange = (e) => setUnread(e.detail.count);
    window.addEventListener('unread-count-changed', handleUnreadChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('unread-count-changed', handleUnreadChange);
    };
  }, []);

  useEffect(() => {
    const fetchFeedbackUnread = () => {
      api.getFeedbackUnreadCount()
        .then(({ data }) => setUnreadFeedback(data.unread_count || 0))
        .catch(() => {});
    };
    fetchFeedbackUnread();
    const interval = setInterval(fetchFeedbackUnread, 30000);

    const handleFeedbackUnread = (e) => setUnreadFeedback(e.detail.count);
    window.addEventListener('feedback-unread-changed', handleFeedbackUnread);

    return () => {
      clearInterval(interval);
      window.removeEventListener('feedback-unread-changed', handleFeedbackUnread);
    };
  }, []);

  // Sayfa değiştiğinde önceki sayfanın scroll pozisyonunu kaydet
  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;
    return () => {
      sessionStorage.setItem(`scrollPos_${location.pathname}`, String(el.scrollTop));
    };
  }, [location.pathname]);

  // Yeni sayfaya geçince scroll'u sıfırla (TaskListPage kendi pozisyonunu restore edecek)
  useEffect(() => {
    const el = mainRef.current;
    if (el) el.scrollTop = 0;
  }, [location.pathname]);

  // Menü dışına tıklayınca kapat
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  const handleLogout = () => {
    setMenuOpen(false);
    logout();
    navigate('/login');
  };

  // Müşteriler sayfasındayken URL'yi kaydet — sekmeye dönünce son konuma gitmek için
  useEffect(() => {
    if (location.pathname.startsWith('/satis/customers')) {
      sessionStorage.setItem(CUSTOMER_RETURN_KEY, `${location.pathname}${location.search || ''}`);
    }
  }, [location.pathname, location.search]);

  const handleCustomersTabClick = (e) => {
    e.preventDefault();
    const saved = sessionStorage.getItem(CUSTOMER_RETURN_KEY);
    navigate(saved && saved.startsWith('/satis/customers') ? saved : '/satis/customers');
  };

  const openNotifications = () => {
    if (location.pathname === '/satis/notifications') {
      const back = sessionStorage.getItem(NOTIFY_RETURN_KEY);
      sessionStorage.removeItem(NOTIFY_RETURN_KEY);
      navigate(back && back.startsWith('/satis') ? back : '/satis');
      return;
    }
    sessionStorage.setItem(NOTIFY_RETURN_KEY, `${location.pathname}${location.search || ''}`);
    navigate('/satis/notifications');
  };

  return (
    <div className="min-h-screen bg-gray-800 flex justify-center overflow-hidden">
    <div className="flex h-dvh max-h-dvh min-h-0 flex-col bg-gray-50 max-w-md w-full relative">
      {/* Üst bar */}
      <header className="shrink-0 bg-white border-b border-gray-100 px-4 flex items-center justify-between z-20" style={{ paddingTop: 'calc(0.75rem + env(safe-area-inset-top, 0px))', paddingBottom: '0.75rem' }}>
        <div className="flex items-center gap-2 min-w-0">
          {showBack && (
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="shrink-0 text-brand-600 pr-1"
              aria-label="Geri"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          <span className="text-lg font-bold text-gray-900 truncate">
            {getPageTitle(location.pathname, location.search)}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <BellIcon count={unread} onOpen={openNotifications} />

          {/* Kullanıcı avatarı + menü */}
          <div className="relative" ref={menuRef}>
            <button
              type="button"
              onClick={() => setMenuOpen(o => !o)}
              className="w-8 h-8 rounded-full bg-brand-500 text-white text-xs font-bold flex items-center justify-center ml-1"
              title={user?.full_name}
            >
              {user?.initials || '?'}
            </button>

            {menuOpen && (
              <div className="absolute right-0 top-10 w-52 bg-white rounded-2xl shadow-lg border border-gray-100 py-2 z-50">
                <div className="px-4 py-2 border-b border-gray-100">
                  <p className="text-sm font-semibold text-gray-900 truncate">{user?.full_name}</p>
                  <p className="text-xs text-gray-400">{ROLE_LABEL[user?.role] || user?.role}</p>
                </div>
                <button
                  type="button"
                  onClick={() => { setMenuOpen(false); navigate('/'); }}
                  className="w-full text-left px-4 py-2.5 text-sm text-gray-700 font-medium hover:bg-gray-50 transition-colors"
                >
                  ← Ana Menü
                </button>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2.5 text-sm text-red-600 font-medium hover:bg-red-50 transition-colors"
                >
                  Çıkış Yap
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Sayfa içeriği — min-h-0: flex içinde yükseklik sınırlanır; böylece overflow burada kalır ve sayfa içi sticky çalışır */}
      <main id="main-scroll" ref={mainRef} className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain pb-[calc(5rem+env(safe-area-inset-bottom,0px))]">
        <div
          style={{
            height: refreshing ? 48 : pullDisplay,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: pullDisplay === 0 && !refreshing ? 'height 0.2s ease' : 'none',
          }}
        >
          <div
            className="w-5 h-5 rounded-full border-2 border-brand-500 border-t-transparent"
            style={{
              transform: refreshing ? undefined : `rotate(${pullDisplay * 4}deg)`,
              animation: refreshing ? 'spin 0.7s linear infinite' : 'none',
            }}
          />
        </div>
        {children}
      </main>

      {/* Alt navigasyon */}
      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-gray-100 flex z-[70] pb-[env(safe-area-inset-bottom,0px)]">
        {tabs.map((tab) => {
          const active = isTabActive(tab.to, location.pathname);
          const onClick = tab.to === '/satis/customers' ? handleCustomersTabClick : undefined;
          const badge = tab.to === '/satis/feedback' && unreadFeedback > 0 ? unreadFeedback : 0;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              onClick={onClick}
              className="flex-1 flex flex-col items-center py-2 gap-0.5"
            >
              <div className="relative">
                {tab.icon(active)}
                {badge > 0 && (
                  <span className="absolute -top-1 -right-1.5 min-w-[14px] h-[14px] bg-red-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center px-0.5">
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-medium ${active ? 'text-brand-500' : 'text-gray-400'}`}>
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </div>
    </div>
  );
}

function isTabActive(tabTo, pathname) {
  if (tabTo === '/satis') {
    return pathname === '/satis' || pathname.startsWith('/satis/tasks');
  }
  if (tabTo === '/calendar') {
    return pathname === '/calendar';
  }
  return pathname === tabTo || pathname.startsWith(`${tabTo}/`);
}

function getPageTitle(path, search = '') {
  if (path === '/calendar') return 'Takvim';
  if (path === '/satis') {
    try {
      const q = new URLSearchParams(search);
      if (q.get('new') === '1') return 'Yeni İş';
    } catch {
      // ignore
    }
    return 'İş Kayıtları';
  }
  if (path.includes('/satis/tasks/') && path.includes('/complete')) return 'Tamamlandı';
  if (path.startsWith('/satis/tasks/')) return 'İş Detayı';
  if (path === '/satis/customers') return 'Müşteriler';
  if (path.startsWith('/satis/customers/')) return 'Müşteri Detayı';
  if (path === '/satis/reports') return 'Raporlar';
  if (path === '/satis/leave') return 'İzin';
  if (path === '/satis/notifications') return 'Bildirimler';
  if (path === '/satis/feedback') return 'Geri Bildirim';
  return 'CETakip';
}
